import { Component, OnInit } from '@angular/core';
import { IToolPanelParams } from 'ag-grid-community';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { GridService } from '../../services/grid.service';
import { ToastService } from '../../services/toast.service';
import { StorageService } from '../../services/storage.service';
import { map, startWith } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
})
export class AdminPanelComponent implements OnInit {
  private params!: IToolPanelParams;
  public newTag: string = '';
  public newShippingTag: string = '';
  public newType: string = '';

  // New brand name and GMC feed options
  public newBrandName: string   = '';
  public gmcBHSChecked: boolean = true;
  public gmcMWSChecked: boolean = true;

  public newBackupName: string = '';
  private onTagValueChangedTimer: any = null;
  private onTypeValueChangedTimer: any = null;
  private onBrandValueChangedTimer: any = null;
  private onShippingTagValueChangedTimer: any = null;

  public allowAddTag: boolean = false;
  public allowDeleteTag: boolean = false;

  public allowDeleteShippingTag: boolean = false;
  public allowAddShippingTag: boolean = false;

  public allowDeleteBrand: boolean = false;
  public allowAddBrand: boolean = false;

  public allowDeleteType: boolean = false;
  public allowAddType: boolean = false;

  public allowCreateBackup: boolean = false;

  public backupList: any = [];
  public backupsSize: string = '';
  public selectedBackup: any = null;
  public selected: Date | null;
  public existDates: any = [];

  public existTag: any = {};
  public existShippingTag: any = {};
  public existType: any = {};
  public existBrand: any = {};

  // public tagsList: any = [];
  tagsCtrl = new FormControl('');
  shippingTagsCtrl = new FormControl('');
  typesCtrl = new FormControl('');
  brandsCtrl = new FormControl('');
  asmTagFormControl = new FormControl('dimensions');

  public tagsList: Observable<any[]> | undefined;
  private allTags: any[] = [];
  private allBrands: any[] = [];
  private shippingAllTags: any[] = [];
  private allTypes: any[] = [];

  public shippingTagsList: Observable<any[]> | undefined;
  public typesList: Observable<any[]> | undefined;
  public brandsList: Observable<any[]> | undefined;

  public asmTags: any = [
    { value: 'dimensions', viewValue: 'Dimensions' },
    { value: 'multi-box-dimensions', viewValue: 'Multi box dimensions' },
    { value: 'free-shipping', viewValue: 'Free shipping' },
    { value: 'free-ship-method', viewValue: 'Free ship method' },
    { value: 'ship-alone', viewValue: 'Ship alone' },
    { value: 'flat-ship-rates', viewValue: 'Flat ship rates' },
    { value: 'origin-zip', viewValue: 'Origin ZIP' },
    { value: 'number-of-boxes', viewValue: 'Number of boxes' },
    { value: 'multi-box-weights', viewValue: 'Multi box weights' },
    { value: 'invalid-ship-methods', viewValue: 'Invalid ship methods' },
    { value: 'markup', viewValue: 'Markup' },
    {
      value: 'global-free-ship-exclusion',
      viewValue: 'Global free ship exclusion',
    },
    { value: 'exclude-states', viewValue: 'Exclude states' },
    { value: 'exclude-countries', viewValue: 'Exclude countries' },
  ];

  constructor(
    private httpService: HttpService,
    private gridService: GridService,
    private toastService: ToastService,
    private storageService: StorageService,
    private router: Router
  ) {
    this.selected = new Date();
    this.storageService.getTags().then(() => {
      this.allTags = this.storageService.tags;
    });
    this.storageService.getBrands().then((brands) => {
      this.allBrands = brands;
    });
    this.storageService.getTypes().then((types) => {
      this.allTypes = types;
    });
    this.shippingAllTags = this.storageService.shippingTags.filter(
      (t) => t.name !== 'Not Selected'
    );

    this.brandsList = this.brandsCtrl.valueChanges.pipe(
      startWith(null),
      map((brand: string | null) =>
        brand ? this._brandsFilter(brand) : this.allBrands.slice()
      )
    );

    this.tagsList = this.tagsCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) =>
        tag ? this._filter(tag) : this.allTags.slice().slice(0, 100)
      )
    );
    //
    this.shippingTagsList = this.shippingTagsCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) =>
        tag ? this._shippingFilter(tag) : this.shippingAllTags.slice()
      )
    );

    this.typesList = this.typesCtrl.valueChanges.pipe(
      startWith(null),
      map((type: string | null) =>
        type ? this._typesFilter(type) : this.allTypes.slice()
      )
    );
  }

  agInit(params: IToolPanelParams): void {
    this.params = params;
  }

  ngOnInit(): void {
    this.getBackupList();
    this.onDateChanged(new Date());
  }

  // https://stackblitz.com/edit/autocomplete-with-virtual-scroll-l2rtvl?file=app%2Fcdk-virtual-scroll-overview-example.ts
  private _shippingFilter(value: any): string[] {
    console.log('_shippingFilter');
    const filterValue = value.name
      ? value.name.toLowerCase()
      : value.toLowerCase();
    return this.shippingAllTags
      .filter((tag) => tag.name.toLowerCase().includes(filterValue))
      .slice(0, 100);
  }

  private _brandsFilter(value: any): string[] {
    const filterValue = value.name
      ? value.name.toLowerCase()
      : value.toLowerCase();
    return this.allBrands
      .filter((brand) => brand.name.toLowerCase().includes(filterValue))
      .slice(0, 100);
  }

  private _typesFilter(value: any): string[] {
    console.log('_typesFilter');
    const filterValue = value.name
      ? value.name.toLowerCase()
      : value.toLowerCase();
    return this.allTypes
      .filter((type) => type.name.toLowerCase().includes(filterValue))
      .slice(0, 100);
  }

  private _filter(value: any): string[] {
    console.log('_filter');
    // console.log('allTags', this.allTags);
    const filterValue = value.name
      ? value.name.toLowerCase()
      : value.toLowerCase();
    // console.log('12filterValue', this.allTags.filter(tag => tag.name.toLowerCase().includes(filterValue)));
    return this.allTags
      .filter((tag) => tag.name.toLowerCase().includes(filterValue))
      .slice(0, 100);
  }

  displayFn(tag: any): string {
    return tag && tag.name ? tag.name : '';
  }

  selectExistShippingTag(event: any) {
    this.onShippingTagValueChanged('');
  }

  selectExistBrand(event: any) {
    this.onBrandValueChanged('');

    if (event.option && event.option.value) {
      const selectedBrand = event.option.value;

      // Find the brand ID from the local storage data
      const localBrand = this.allBrands.find(
        (b: any) => b.name === selectedBrand
      );

      this.gmcBHSChecked = localBrand.GMCFeedBHS === true;
      this.gmcMWSChecked = localBrand.GMCFeedMWS === true;
    }
  }

  selectExistType(event: any) {
    this.onTypeValueChanged('');
  }

  selectExistTag(event: any) {
    this.onTagValueChanged('');
    // console.log('selectExistTag mmds network disk manager hello world of wifi junk connector fooset top heighs user item lorem ipsum dolor sit ametINCLUDES_+__');
  }

  getBackupList() {
    this.httpService
      .get(environment.API_PATH + '/backup')
      .subscribe((response) => {
        // this.backupList = response.data;
        this.backupsSize = response.size;
        this.existDates = [];
        setTimeout(() => {
          this.existDates = response.data.map((x: any) => {
            const data = new Date(x.created_at);
            const d = data.getDate();
            const m = data.getMonth();
            const y = data.getFullYear();

            return [d, m, y];
          });
          console.log('existDates', this.existDates);
        }, 100);
      });
  }

  deleteTag() {
    // console.log('deleteTag', this.existTag);
    this.httpService
      .delete(environment.API_PATH + `/tag/${this.existTag._id}`)
      .subscribe((resp) => {
        console.log(resp);
        this.toastService.info('The tag has been successfully deleted.');
        this.storageService.getTags().then(() => {
          this.allTags = this.storageService.tags;
          this.newTag = '';
          this.allowDeleteTag = false;
        });
      });
  }

  deleteType() {
    console.log('deleteType', this.existType);
    this.httpService
      .delete(environment.API_PATH + `/type/${this.existType._id}`)
      .subscribe((resp) => {
        this.toastService.info('The type has been successfully deleted.');
        this.storageService.getTypes().then((types) => {
          this.allTypes = types;
          this.newType = '';
          this.allowDeleteType = false;
        });
      });
  }

  deleteBrand() {
    this.httpService
      .delete(environment.API_PATH + `/brand/${this.existBrand._id}`)
      .subscribe((resp) => {
        this.toastService.info('The brand has been successfully deleted.');
        this.storageService.getBrands().then((brands) => {
          this.allBrands = brands;
          this.newBrandName = '';
          this.allowDeleteBrand = false;
        });
      });
  }

  deleteShippingTag() {
    console.log('deleteShippingTag', this.existShippingTag);
    this.httpService
      .delete(
        environment.API_PATH + `/tag/shipping/${this.existShippingTag._id}`
      )
      .subscribe((resp) => {
        this.toastService.info(
          'The shipping tag has been successfully deleted.'
        );
        this.storageService.getShippingTags().then((tags) => {
          this.shippingAllTags = tags;
          this.newShippingTag = '';
          this.allowDeleteShippingTag = false;
        });
      });
  }

  onBrandValueChanged(event: any) {
    clearTimeout(this.onBrandValueChangedTimer);
    if (this.newBrandName.length) {
      this.onBrandValueChangedTimer = setTimeout(() => {
        this.httpService
          .post(environment.API_PATH + '/brand/checkExist', {
            brand: this.newBrandName,
          })
          .subscribe((resp) => {
            if (resp.brands === null) {
              this.allowAddBrand = true;
              this.allowDeleteBrand = false;
            } else {
              this.existBrand = resp.brands;
              this.allowAddBrand = false;
              this.allowDeleteBrand = true;
            }
          });
      }, 300);
    } else {
      this.allowAddBrand = false;
      this.allowDeleteBrand = false;
    }
  }

  onTypeValueChanged(event: any) {
    clearTimeout(this.onTypeValueChangedTimer);
    if (this.newType.length) {
      this.onTypeValueChangedTimer = setTimeout(() => {
        this.httpService
          .post(environment.API_PATH + '/type/checkExist', {
            type: this.newType,
          })
          .subscribe((resp) => {
            if (resp.types === null) {
              this.allowAddType = true;
              this.allowDeleteType = false;
            } else {
              this.existType = resp.types;
              this.allowAddType = false;
              this.allowDeleteType = true;
            }
          });
      }, 300);
    } else {
      this.allowAddType = false;
      this.allowDeleteType = false;
    }
  }

  onShippingTagValueChanged(event: any) {
    clearTimeout(this.onShippingTagValueChangedTimer);
    if (this.newShippingTag.length) {
      this.onShippingTagValueChangedTimer = setTimeout(() => {
        this.httpService
          .post(environment.API_PATH + '/tag/checkExistShipping', {
            tag: this.newShippingTag,
          })
          .subscribe((resp) => {
            if (resp.tags === null) {
              this.allowAddShippingTag = true;
              this.allowDeleteShippingTag = false;
            } else {
              this.existShippingTag = resp.tags;
              this.allowAddShippingTag = false;
              this.allowDeleteShippingTag = true;
            }
          });
      }, 300);
    } else {
      this.allowDeleteShippingTag = false;
      this.allowAddShippingTag = false;
    }
  }

  onTagValueChanged(event: any) {
    // console.log('onTagValueChanged', this.newTag);
    clearTimeout(this.onTagValueChangedTimer);
    if (this.newTag.length) {
      this.onTagValueChangedTimer = setTimeout(() => {
        this.httpService
          .post(environment.API_PATH + '/tag/checkExist', {
            tag: this.newTag,
          })
          .subscribe((resp) => {
            console.log('onTagValueChanged', resp);
            if (resp.tags === null) {
              this.allowAddTag = true;
              this.allowDeleteTag = false;
            } else {
              this.existTag = resp.tags;
              this.allowAddTag = false;
              this.allowDeleteTag = true;
            }
          });
      }, 300);
    } else {
      this.allowAddTag = false;
      this.allowDeleteTag = false;
    }
  }

  addBrand() {
    const brand = {
      name: this.newBrandName,
      GMCFeedBHS: this.gmcBHSChecked,
      GMCFeedMWS: this.gmcMWSChecked,
    };
    console.log(
      'this.newBrandName',
      this.newBrandName,
      'this.gmcBHSChecked',
      this.gmcBHSChecked,
      'this.gmcMWSChecked',
      this.gmcMWSChecked
    );
    this.httpService
      .post(environment.API_PATH + '/brand/add', {
        brand,
      })
      .subscribe(() => {
        this.newBrandName = '';
        this.allowAddBrand = false;
        this.toastService.success('New brand successfully created');
        this.storageService.getBrands().then((brands) => {
          this.allBrands = brands;
        });
        this.gridService.gridApi?.refreshServerSide();
        this.gridService.productionGridApi?.refreshServerSide();
        this.gridService.historyGridApi?.refreshServerSide();
        this.gridService.changesGridApi?.refreshServerSide();
      });
  }

  addType() {
    this.httpService
      .post(environment.API_PATH + '/type/add', {
        type: this.newType,
      })
      .subscribe(() => {
        this.newType = '';
        this.allowAddType = false;
        this.toastService.success('New type successfully created');
        this.storageService.getTypes().then((types) => {
          this.allTypes = types;
        });
        this.gridService.gridApi?.refreshServerSide();
        this.gridService.productionGridApi?.refreshServerSide();
        this.gridService.historyGridApi?.refreshServerSide();
        this.gridService.changesGridApi?.refreshServerSide();
      });
  }

  addShippingTag() {
    this.httpService
      .post(environment.API_PATH + '/tag/addShipping', {
        tag: this.newShippingTag,
      })
      .subscribe((res) => {
        this.newShippingTag = '';
        this.allowAddShippingTag = false;
        this.toastService.success('New shipping tag successfully created');
        this.storageService.getShippingTags().then((tags) => {
          this.shippingAllTags = tags;
        });
        this.gridService.gridApi?.refreshServerSide();
        this.gridService.productionGridApi?.refreshServerSide();
        this.gridService.historyGridApi?.refreshServerSide();
        this.gridService.changesGridApi?.refreshServerSide();
      });
  }

  addTag() {
    this.httpService
      .post(environment.API_PATH + '/tag/add', {
        tag: this.newTag,
      })
      .subscribe((res) => {
        this.newTag = '';
        this.allowAddTag = false;
        this.toastService.success('New tag successfully created');
        this.storageService.getTags().then(() => {
          this.allTags = this.storageService.tags;
        });
        this.gridService.gridApi?.refreshServerSide();
        this.gridService.productionGridApi?.refreshServerSide();
        this.gridService.historyGridApi?.refreshServerSide();
        this.gridService.changesGridApi?.refreshServerSide();
      });
  }

  onBackupCreate(): void {
    this.allowCreateBackup = false;
    this.gridService.gridApi?.showLoadingOverlay();
    this.gridService.productionGridApi?.showLoadingOverlay();
    this.gridService.historyGridApi?.showLoadingOverlay();
    this.gridService.changesGridApi?.showLoadingOverlay();
    this.toastService.info('Backup has been started. Please wait.');

    this.httpService
      .post(environment.API_PATH + '/backup/create', {
        name: this.newBackupName.trim(),
      })
      .subscribe(() => {
        this.newBackupName = '';
        this.toastService.success('Backup created successfully.');
        this.getBackupList();
        this.onDateChanged(new Date());
      });
  }

  onBackupRestore(): void {
    if (confirm('Are you sure?')) {
      this.gridService.gridApi?.showLoadingOverlay();
      this.gridService.productionGridApi?.showLoadingOverlay();
      this.gridService.historyGridApi?.showLoadingOverlay();
      this.gridService.changesGridApi?.showLoadingOverlay();
      this.toastService.info('Backup restore has been started. Please wait.');

      this.httpService
        .post(environment.API_PATH + '/backup/restore', {
          _id: this.selectedBackup,
        })
        .subscribe((response) => {
          this.selectedBackup = null;
          this.toastService.success(response);
        });
    }
  }

  newBackupNameChange(event: any) {
    if (this.newBackupName.length) {
      this.allowCreateBackup = true;
    }
    // this.newBackupName = event.value;
  }

  onDateChanged(event: any) {
    console.log('onDateChanged', event);
    const date = new Date(event);
    console.log(date.getFullYear(), date.getMonth() + 1, date.getDate());
    // const resultDate = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
    this.httpService
      .post(environment.API_PATH + '/backup/filterByDate', {
        // date: resultDate.toISOString().split('T')[0]
        date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
      })
      .subscribe((response) => {
        this.backupList = [];
        setTimeout(() => {
          if (response.length) {
            this.backupList = response;
          } else {
            this.backupList = [];
          }
        }, 300);
      });
  }

  backupOnChange(event: any) {
    console.log('backupOnChange', event.value);
    this.selectedBackup = event.value;
  }

  dateClass = (d: Date) => {
    const date = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    return this.existDates.find(
      (x: any) => x[0] === date && x[1] === month && x[2] === year
    )
      ? 'backup-calendar-exist-records'
      : '';
  };

  goToImageSync() {
    this.router.navigate(['/image-sync']);
  }
}
